import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c96c4ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "no-ppc-data"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "ppc-content"
};
const _hoisted_4 = {
  class: "ppc-data"
};
const _hoisted_5 = {
  class: "currency-percentage"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "of-budget"
}, "of budget", -1));
const _hoisted_7 = {
  key: 1,
  class: "percentage alert"
};
const _hoisted_8 = {
  key: 0,
  class: "last-budget"
};
const _hoisted_9 = {
  key: 0,
  class: "red"
};
const _hoisted_10 = {
  key: 1,
  class: "yellow"
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  key: 1,
  class: "no-budget"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ppc-spend-tooltip-header"
}, "End of week spend forecast", -1));
const _hoisted_14 = {
  class: "ppc-spend-tooltip-body"
};
const _hoisted_15 = {
  class: "forecast"
};
const _hoisted_16 = {
  class: "details"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "EoW Spend forecast", -1));
const _hoisted_18 = {
  class: "content"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "of-budget"
}, "of budget", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "33",
  height: "25",
  viewBox: "0 0 33 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M0.5 0C0.223858 0 0 0.223858 0 0.5C0 0.776142 0.223858 1 0.5 1V0.5V0ZM28.1464 24.8536C28.3417 25.0488 28.6583 25.0488 28.8536 24.8536L32.0355 21.6716C32.2308 21.4763 32.2308 21.1597 32.0355 20.9645C31.8403 20.7692 31.5237 20.7692 31.3284 20.9645L28.5 23.7929L25.6716 20.9645C25.4763 20.7692 25.1597 20.7692 24.9645 20.9645C24.7692 21.1597 24.7692 21.4763 24.9645 21.6716L28.1464 24.8536ZM0.5 0.5V1H20.5V0.5V0H0.5V0.5ZM28.5 8.5H28V24.5H28.5H29V8.5H28.5ZM20.5 0.5V1C24.6421 1 28 4.35786 28 8.5H28.5H29C29 3.80558 25.1944 0 20.5 0V0.5Z",
  fill: "#BFBFBF"
})], -1));
const _hoisted_21 = {
  class: "week-spend"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "25",
  viewBox: "0 0 17 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M15.682 25C15.9581 25 16.182 24.7761 16.182 24.5C16.182 24.2239 15.9581 24 15.682 24V24.5V25ZM4.03554 0.146446C3.84028 -0.0488167 3.52369 -0.0488167 3.32843 0.146446L0.14645 3.32843C-0.0488119 3.52369 -0.0488119 3.84027 0.14645 4.03553C0.341713 4.23079 0.658295 4.23079 0.853558 4.03553L3.68198 1.20711L6.51041 4.03553C6.70567 4.23079 7.02226 4.23079 7.21752 4.03553C7.41278 3.84027 7.41278 3.52369 7.21752 3.32843L4.03554 0.146446ZM15.682 24.5V24H11.682V24.5V25H15.682V24.5ZM3.68198 16.5H4.18198V0.5H3.68198H3.18198V16.5H3.68198ZM11.682 24.5V24C7.53985 24 4.18198 20.6421 4.18198 16.5H3.68198H3.18198C3.18198 21.1944 6.98756 25 11.682 25V24.5Z",
  fill: "#BFBFBF"
})], -1));
const _hoisted_23 = {
  class: "details"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "Current week spend", -1));
const _hoisted_25 = {
  class: "content"
};
const _hoisted_26 = {
  class: "footer"
};
const _hoisted_27 = {
  class: "weekly-budget"
};
const _hoisted_28 = {
  key: 0,
  class: "budget-line",
  width: "2",
  height: "20",
  viewBox: "0 0 2 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_29 = ["stroke-dasharray"];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "Weekly Budget", -1));
const _hoisted_31 = {
  class: "content"
};
const _hoisted_32 = {
  key: 0,
  class: "last-budget"
};
const _hoisted_33 = {
  key: 0,
  class: "red"
};
const _hoisted_34 = {
  key: 1,
  class: "yellow"
};
const _hoisted_35 = {
  key: 2
};
const _hoisted_36 = {
  key: 1,
  class: "no-budget"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_spend_bar = _resolveComponent("spend-bar");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(), _createBlock(_component_b_td, {
    class: _normalizeClass(["portfolio-td-workspace ppc-spend", {
      'border-top': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-right': !$props.portfolio.collapsed,
      'border-bottom': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.isLastSellerInWorkspace,
      'border-radius-top-right': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-radius-bottom-right': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.isLastSellerInWorkspace
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_loading_element, {
      loading: $props.loading
    }, {
      default: _withCtx(() => [$props.portfolio.ppc_status == null ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No PPC data available ")) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["ppc", [{
          alert: _ctx.ppcForecastStatus($props.portfolio) == 'ALERT' || _ctx.ppcForecastStatus($props.portfolio) == 'NO BUDGET'
        }, {
          warning: _ctx.ppcForecastStatus($props.portfolio) == 'WARNING'
        }]]),
        id: _ctx.buildPortfolioTargetId($props.portfolio, 'spend')
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_currency_value, {
        value: $props.portfolio.ppc_forecast,
        precision: "2"
      }, null, 8, ["value"]), _ctx.ppcForecastShareOfBudget($props.portfolio) && _ctx.ppcForecastStatus($props.portfolio) != 'NO BUDGET' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["percentage", [{
          alert: _ctx.ppcForecastStatus($props.portfolio) == 'ALERT'
        }, {
          warning: _ctx.ppcForecastStatus($props.portfolio) == 'WARNING'
        }]])
      }, [_createVNode(_component_percentage_value, {
        value: _ctx.ppcForecastShareOfBudget($props.portfolio),
        showSymbol: true,
        precision: 1
      }, {
        append: _withCtx(() => [_hoisted_6]),
        _: 1
      }, 8, ["value"])], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_7, "No budget"))]), _createVNode(_component_spend_bar, {
        portfolio: $props.portfolio
      }, null, 8, ["portfolio"])]), _ctx.ppcForecastStatus($props.portfolio) != 'NO BUDGET' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_ctx.ppcDaysToNewBudgetStrategyStatus($props.portfolio) == 'ALERT' ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Last budget strategy expired " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ago ", 1)) : _ctx.ppcDaysToNewBudgetStrategyStatus($props.portfolio) == 'WARNING' ? (_openBlock(), _createElementBlock("div", _hoisted_10, " New budget strategy due in " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, " New budget strategy due in " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ", 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_12))]), _createVNode(_component_app_popover, {
        target: _ctx.buildPortfolioTargetId($props.portfolio, 'spend'),
        placement: "top",
        customClass: "ppc-spend-tooltip"
      }, {
        default: _withCtx(() => [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createVNode(_component_currency_value, {
          value: $props.portfolio.ppc_forecast,
          precision: "2"
        }, null, 8, ["value"]), _ctx.ppcForecastStatus($props.portfolio) != 'NO BUDGET' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["percentage", [{
            alert: _ctx.ppcForecastStatus($props.portfolio) == 'ALERT'
          }, {
            warning: _ctx.ppcForecastStatus($props.portfolio) == 'WARNING'
          }]])
        }, [_createVNode(_component_percentage_value, {
          value: _ctx.ppcForecastShareOfBudget($props.portfolio),
          showSymbol: true,
          precision: 1
        }, {
          append: _withCtx(() => [_hoisted_19]),
          _: 1
        }, 8, ["value"])], 2)) : _createCommentVNode("", true)])]), _hoisted_20]), _createVNode(_component_spend_bar, {
          portfolio: $props.portfolio
        }, null, 8, ["portfolio"]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createVNode(_component_currency_value, {
          value: $props.portfolio.ppc_spend,
          precision: "2"
        }, null, 8, ["value"])])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_ctx.ppcWeeklyBudget($props.portfolio) ? (_openBlock(), _createElementBlock("svg", _hoisted_28, [_createElementVNode("path", {
          d: "M1 1V19",
          stroke: "#1755AB",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-dasharray": $options.budgetLineDashArray($props.portfolio)
        }, null, 8, _hoisted_29)])) : _createCommentVNode("", true), _hoisted_30, _createElementVNode("div", _hoisted_31, [_createVNode(_component_currency_value, {
          value: _ctx.ppcWeeklyBudget($props.portfolio),
          precision: "2"
        }, null, 8, ["value"])])]), _ctx.ppcForecastStatus($props.portfolio) != 'NO BUDGET' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_ctx.ppcDaysToNewBudgetStrategyStatus($props.portfolio) == 'ALERT' ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Last budget strategy expired " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ago ", 1)) : _ctx.ppcDaysToNewBudgetStrategyStatus($props.portfolio) == 'WARNING' ? (_openBlock(), _createElementBlock("div", _hoisted_34, " New budget strategy due in " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_35, " New budget strategy due in " + _toDisplayString(_ctx.ppcDaysToNewBudgetStrategy($props.portfolio)) + " days ", 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_36))])])]),
        _: 1
      }, 8, ["target"])], 10, _hoisted_2))]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["class"]);
}